import { html as runeHtml } from 'rune-ts';
import { html as fxjsHtml } from 'fxjs/es';

type IconProps = {
  html?: typeof runeHtml | typeof fxjsHtml;
  klass?: string;
};

export const makePlusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_7292_5182)">
      <path
        d="M21.12 11.12H12.87V2.88C12.87 2.4 12.48 2 11.99 2C11.5 2 11.11 2.39 11.11 2.88V11.13H2.88C2.4 11.13 2 11.52 2 12.01C2 12.5 2.39 12.89 2.88 12.89H11.13V21.14C11.13 21.62 11.52 22.02 12.01 22.02C12.5 22.02 12.89 21.63 12.89 21.14V12.89H21.14C21.62 12.89 22.02 12.5 22.02 12.01C22.02 11.52 21.63 11.13 21.14 11.13L21.12 11.12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7292_5182">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeMinusIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0_7067_101637)">
      <path
        d="M20.9991 12.8791H2.99914C2.51914 12.8791 2.11914 12.4891 2.11914 11.9991C2.11914 11.5091 2.50914 11.1191 2.99914 11.1191H20.9991C21.4791 11.1191 21.8791 11.5091 21.8791 11.9991C21.8791 12.4891 21.4891 12.8791 20.9991 12.8791Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7067_101637">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const makeFaqLinkIcon = ({ html = runeHtml, klass = '' }: IconProps = {}) => html`
  <svg
    class="${klass}"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M17.0931 10.9682C16.72 10.9682 16.409 11.2714 16.409 11.6523V16.3166C16.409 16.371 16.3624 16.4099 16.3158 16.4099H3.68332C3.6289 16.4099 3.59003 16.3632 3.59003 16.3166L3.58987 3.68413C3.58987 3.62972 3.63651 3.59085 3.68316 3.59085H8.34744C8.72058 3.59085 9.03154 3.28767 9.03154 2.90675C9.03154 2.52583 8.72836 2.22266 8.34744 2.22266H3.68316C2.88245 2.22266 2.22168 2.87566 2.22168 3.68413L2.22184 16.3166C2.22184 17.1173 2.87484 17.7781 3.68332 17.7781H16.3158C17.1165 17.7781 17.7772 17.1251 17.7772 16.3166V11.6523C17.7772 11.2791 17.4741 10.9682 17.0931 10.9682Z"
      fill="currentColor"
    />
    <path
      d="M17.7617 2.87566C17.7617 2.79792 17.7461 2.71241 17.715 2.64244C17.6839 2.57248 17.6451 2.51806 17.5907 2.46364C17.5829 2.4481 17.5751 2.43255 17.5673 2.42478C17.5518 2.40923 17.5362 2.40923 17.5207 2.39368C17.4663 2.34704 17.4119 2.30817 17.3497 2.27707C17.2642 2.24598 17.1787 2.22266 17.0854 2.22266H12.4211C12.0479 2.22266 11.737 2.52583 11.737 2.90675C11.737 3.28767 12.0402 3.59085 12.4211 3.59085H15.4451L9.51368 9.52226C9.24937 9.78657 9.24937 10.2219 9.51368 10.4862C9.64583 10.6184 9.82463 10.6883 9.99565 10.6883C10.1667 10.6883 10.3455 10.6261 10.4776 10.4862L16.409 4.5548V7.57881C16.409 7.95195 16.7122 8.26291 17.0931 8.26291C17.4741 8.26291 17.7772 7.95973 17.7772 7.57881V2.90675C17.7772 2.90675 17.7772 2.8912 17.7772 2.88343L17.7617 2.87566Z"
      fill="currentColor"
    />
  </svg>
`;
